import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { getAdminPetTypes, type AdminPetTypeSummary } from '../lib/api';
import './AdminPetTypesPage.css';

function titleCase(value: string) {
  return value.replace(/[_-]+/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export default function AdminPetTypesPage() {
  const { getAccessTokenSilently } = useAuth0();
  const [rows, setRows] = useState<AdminPetTypeSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    void getAccessTokenSilently().then((token) => {
      if (!token) throw new Error('Missing access token');
      return getAdminPetTypes(token);
    }).then((result) => {
      if (active) setRows(result);
    }).catch((loadError: unknown) => {
      if (active) setError(loadError instanceof Error ? loadError.message : 'Unable to load pet types.');
    }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [getAccessTokenSilently]);

  return <>
    <div className="facility-page-heading"><div><p className="eyebrow">Administration</p><h1>Pets</h1><p>Pet counts grouped by type, with the most recently created pet in each group.</p></div></div>
    {error && <p className="form-error facility-error" role="alert">{error}</p>}
    {loading ? <p className="facility-empty">Loading pet types...</p> : rows.length === 0 ? <p className="facility-empty">No pets have been added yet.</p> : <div className="admin-pet-types-table-wrap"><table className="admin-pet-types-table"><thead><tr><th scope="col">Pet Type</th><th scope="col">Number</th><th scope="col">Date Created (most recent)</th></tr></thead><tbody>{rows.map((row) => <tr key={row.species}><th scope="row">{titleCase(row.species)}</th><td>{row.number.toLocaleString()}</td><td>{row.most_recent_created_at ? new Date(row.most_recent_created_at).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : '—'}</td></tr>)}</tbody></table></div>}
  </>;
}
